<template>
    <div class='bottom'>
        <logo color="white"/>
        <div class='text'>
            <a class="text1" href="https://beian.miit.gov.cn" >备案号：鲁ICP备2023002106号-1</a>
            <div class="text2">
        	    <img alt="PoliceLogo" src="../assets/police.png" height="13"/>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=37010302001373">鲁公网安备 37010302001373号</a>
            </div>
            <div class="text3">&copy;2022-2025, 安链万家软件（香港）有限公司</div>
        </div>
    </div>
</template>


<script>
import logo from './logo.vue'

export default {
    components:{
        logo
    }
}
</script>

<style scoped>
.bottom {
    background-color: #000;
    color: white;
    margin: 0 auto;
    position: relative;
}
.bottom div, .bottom a{
    color: white;
    text-decoration: none;
}

@media (min-width: 1080px) {
    .bottom {
        width: 7.711rem;
        height: 1rem;
    }

    .text {
        position: absolute;
        bottom: 0;
        right: 0;
    }

    .text1 {
        position: absolute;
        bottom: 0;
        right: 2.65rem;
        width: 4rem;
    }

    .text2 {
        position: absolute;
        bottom: 0;
        right: 0.6rem;
        width: 4rem;
    }
}

@media screen and (max-width: 1080px) and (min-width: 768px) {
    .bottom {
        width: 100%;
        height: 20vw;
    }

    .text {
        position: absolute;
        bottom: 0;
        right: 1vw;
    }

    .text1 {
        position: absolute;
        right: 0;
        bottom: 7.3vw;
    }

    .text2 {
        position: absolute;
        right: 0;
        bottom: 3.5vw;
    }
}

@media screen and (max-width: 768px) {
    .bottom {
        width: 100%;
        height: 20vw;
    }

    .space {
        display:none
    }

    .text {
        position: absolute;
        bottom: 0;
        right: 1vw;
    }

    .text1 {
        position: absolute;
        right: 0;
        bottom: 7.3vw;
    }

    .text2 {
        position: absolute;
        right: 0;
        bottom: 3.5vw;
    }
}

</style>